module.exports = __webpack_public_path__ + "img/ten-o'clock.08df20bb.png";